var emailCapture = require('../mixins/email_capture.mixin');
var tagManagement = require('../utils/tag_management.utils');
const NEWSLETTER_SUBSCRIPTION_ENDPOINT = '/frontend-home/service/subscriptions/newsletter/subscribe';
const SUBSCRIPTION_HEADERS = {'Content-Type': 'application/json;charset=UTF-8'};

var NewsletterSubscription = emailCapture.extend({
    init: function($emailContainer, moduleContext, campaign) {
        campaign = campaign || 'default_newsletter';
        if ('hidden' === Odigeo.Session.get('newsletterVisibility')) {
            $emailContainer.hide();
            return;
        }
        this.initEmailCapture();
        var globalScope = Odigeo.Utils.getFunnelInGlobalScope();
        this.trackKeys = {'home': _.isEmpty(globalScope)? 'home' : globalScope + '_tab'};
        this.$slctrs = {
            container: $emailContainer,
            prismaContainer: $emailContainer.find('.newsletter_prisma'),
            input: $emailContainer.find('.newsletter_input'),
            button: $emailContainer.find('.newsletter_button'),
            closeButton: $emailContainer.find('.newsletter_close'),
            legalInput: $emailContainer.find('.newsletter_legal'),
            successIcon: $emailContainer.find('.newsletter_success_icon'),
            successMessage: $emailContainer.find('.od_newsletter_success_message'),
        };
        this.moduleContext = moduleContext;
        this.action = 'newsletter_widget';
        this.labelConcept = 'newsletter_subscription_';
        this.hasLegal = !_.isEmpty(this.$slctrs.legalInput);
        this.requestCount = 0;
        this.campaign = campaign;

        this.$slctrs.container.removeClass('not-visible');
        this.bindNewsletterEvents();
    },
    bindNewsletterEvents: function() {
        this.$slctrs.closeButton.on(Odigeo.Events.tap, _.bind(this.closeNewsletterSubscription, this));
        this.$slctrs.button.on(Odigeo.Events.tap, _.bind(this.validateEmailCapture, this));
        this.$slctrs.input.on(Odigeo.Events.keydown, _.bind(this.onKeyDown, this));
        this.$slctrs.input.on(Odigeo.Events.focus, _.bind(this.onFocus, this));
        this.$slctrs.input.on(Odigeo.Events.blur, _.bind(this.onBlur, this));
        if (this.hasLegal) {
            this.$slctrs.legalInput.on(Odigeo.Events.change, _.bind(this.resetLegalNewsletterSubscription, this));
        }
    },

    onKeyDown: function(evt) {
        if (evt.keyCode === Odigeo.Events.keys.KEY_RETURN) {
            this.validateEmailCapture(evt);
        }
    },

    onFocus: function() {
        this.$slctrs.prismaContainer.addClass('focused');
    },

    onBlur: function() {
        this.$slctrs.prismaContainer.removeClass('focused');
    },

    onSuccess: function() {
        const email = this.$slctrs.input.val();
        const campaign = this.campaign;
        const self = this;

        if (this.hasLegal) {
            this.resetLegalNewsletterSubscription();
        }

        $.ajax({
            url: NEWSLETTER_SUBSCRIPTION_ENDPOINT,
            type: 'POST',
            headers: SUBSCRIPTION_HEADERS,
            data: JSON.stringify({
                email: email,
                campaign: campaign,
            }),
            dataType: 'json',
        }).done(function() {
            tagManagement.fireEvent('submit_newsletter', 'customer_email', email);
            self.showSentMessageEmailCapture();
            self.$slctrs.button.addClass('loading');
            setTimeout(_.bind(self.successAnimation, self), 750);
            setTimeout(_.bind(self.closeNewsletterSubscription, self), 10000);
        }).fail(function() {
            self.requestCount++;
            if (5 > self.requestCount) {
                self.onSuccess();
            } else {
                self.closeNewsletterSubscription();
            }
        });
    },

    successAnimation: function() {
        this.$slctrs.successIcon.addClass('active');
    },

    closeNewsletterSubscription: function(e) {
        this.$slctrs.container.addClass('not-visible');
        Odigeo.Session.set('newsletterVisibility', 'hidden');
        var label = 'close_' + (_.isEmpty(e) ? '1' : '0');
        this.trackEventsEmailCapture(label);
    },

    resetLegalNewsletterSubscription: function() {
        this.$slctrs.legalInput.parent().removeClass('error');
    },
});
module.exports = NewsletterSubscription;
